import { Handle, Position } from "@xyflow/react";
import { FlowHandle } from "./commons/flowHandle";

export default function StartNode({ id }) {
  return (
    <span
      className="d-inline-flex align-items-center justify-content-center rounded-pill text-white fw-medium"
      style={{
        backgroundColor: '#6366F1',
        padding: '4px 12px',
        fontSize: '0.875rem',
        fontFamily: 'Inter, system-ui, Segoe UI, Roboto, sans-serif',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
        width: '90px',
        height: '28px',
        cursor: 'pointer'
      }}
      onMouseEnter={(e) => e.target.style.backgroundColor = '#6366F1'}
      onMouseLeave={(e) => e.target.style.backgroundColor = '#6366F1'}
    >
      <FlowHandle type="source" position={Position.Right} />
      {/* <svg viewBox="0 0 6 6" aria-hidden="true" className="me-3" style={{ width: '6px', height: '6px', fill: 'white', marginRight: '8px' }}>
        <circle r={3} cx={3} cy={3} />
      </svg> */}
      Begin
    </span>
  );
}
